import { useState } from "react";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { useFilterContext } from "./context";

const ListFilter = ({
	type,
	options,
	onApply,
	activeOptions = [],
	onScroll,
	isLoadingMore,
	onSearch,
	confirmLabel = "Filtra",
}) => {
	const { setIsOpen } = useFilterContext();

	const [selectedValues, setSelectedValues] = useState(activeOptions);

	const handleChange = (value) => {
		if (type === "radio") {
			setSelectedValues([value]);
		} else if (type === "checkbox") {
			const newSelectedValues = selectedValues.some(
				(item) => JSON.stringify(item) === JSON.stringify(value)
			)
				? selectedValues.filter((v) => JSON.stringify(v) !== JSON.stringify(value))
				: [...selectedValues, value];
			setSelectedValues(newSelectedValues);
		}
	};

	const handleApply = () => {
		if (type === "radio") {
			onApply(selectedValues[0]);
		} else if (type === "checkbox") {
			onApply(selectedValues);
		}
		setIsOpen(false);
	};

	const inputProps = {
		checkbox: {
			className: "check_landing small",
			type: "checkbox",
		},
		radio: {
			className: "radio_landing small",
			type: "radio",
		},
	};

	return (
		<div className="min-w-[240px]">
			{onSearch && (
				<div className="p-5 shadow-[inset_0_-1px] shadow-dark-10">
					<div className="wrap_input_landing icon">
						<input
							onChange={(e) => {
								onSearch?.handler(e.target.value.trim().toLocaleLowerCase());
							}}
							defaultValue={onSearch.value}
							className="landing"
							placeholder="Ricerca..."
							type="text"
						/>
						<span className="icon_16 default search"></span>
					</div>
				</div>
			)}

			<OverlayScrollbarsComponent
				defer
				options={{ scrollbars: { autoHide: "scroll" } }}
				className="flex-1 min-h-[150px] max-h-[220px] overflow-auto"
				events={{
					scroll: (e) => {
						const { content } = e.elements();
						onScroll({ target: content });
					},
				}}
			>
				<div className="grid gap-3 px-5 py-5">
					{options.length > 0 ? (
						<>
							{options.map((option, index) => (
								<div key={JSON.stringify(option.value)} className={inputProps?.[type].className}>
									<input
										type={inputProps?.[type]?.type}
										onChange={() => handleChange(option.value)}
										checked={selectedValues.some(
											(item) => JSON.stringify(item) === JSON.stringify(option.value)
										)}
										id={`item-option-${JSON.stringify(option.id || option.value)}`}
									/>
									<label
										htmlFor={`item-option-${JSON.stringify(option.id || option.value)}`}
										className="icon"
									>
										{option.icon && option.icon}
										{option.label}
									</label>
								</div>
							))}
							{isLoadingMore && (
								<div className="flex items-center justify-center">
									<span className="icon_16 default loader" />
								</div>
							)}
						</>
					) : (
						<div className="text-center py-8">
							<div className="text-14 font-semibold">Nessun filtro trovato</div>
							<div className="text-13 text-dark-70 pt-2">Prova con un'altra ricerca</div>
						</div>
					)}
				</div>
			</OverlayScrollbarsComponent>

			<div className="shadow-[0_-1px_0] shadow-dark-10 p-5">
				<button type="button" className="button fill small primary w-full" onClick={handleApply}>
					{confirmLabel}
				</button>
			</div>
		</div>
	);
};

export default ListFilter;
